import { useQuery } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import { getPortfolioIdDocumentsV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePortfolioDocumentsQuery = (id: number) => {
	return useQuery({
		queryKey: PortfolioKeys.documents(id),
		queryFn: processResponse(() => getPortfolioIdDocumentsV2(id)),
	});
};
